import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearLoader from "../../../Loader/LinearLoader";
import { numberDecimal } from "../../../../../utils/numberFormats";
import { AUDIENCE_BY_INTERESTS } from "../../../../../locales/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";

const InfluencerAudienceInterests = ({ data = "" }) => {
  const { t } = useTranslationApp();

  if (data.length === 0) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {t(AUDIENCE_BY_INTERESTS)}
      </Typography>
      {data.map((interest, index) => {
        if (index < 10) {
          return (
            <LinearLoader
              label={interest.name}
              value={numberDecimal(interest.value)}
              key={interest.name}
            />
          );
        }
        return null;
      })}
    </Box>
  );
};

export default InfluencerAudienceInterests;
